var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-field',{attrs:{"label":_vm.$t('payment.more_details')}},[_c('div',{staticClass:"stripe-payment-container"},[_c('div',{staticClass:"vca-input-border"},[_c('div',{ref:"card",staticClass:"stripe-payment",attrs:{"id":"card"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }